var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",class:{'visible': _vm.state == 1, 'visible active': _vm.state == 2},attrs:{"von-loading":""}},[_c('div',{staticClass:"toptip"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }